import { render, staticRenderFns } from "./ProfessionalApplicationAttachmentList.vue?vue&type=template&id=65d16d2a&scoped=true&"
import script from "./ProfessionalApplicationAttachmentList.vue?vue&type=script&lang=js&"
export * from "./ProfessionalApplicationAttachmentList.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalApplicationAttachmentList.vue?vue&type=style&index=0&id=65d16d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d16d2a",
  null
  
)

export default component.exports